/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibility-enum';
import { Company } from './company';
import { DeckPitchDetailLimitPaymentOptionsTo } from './deck-pitch-detail-limit-payment-options-to';
import { TotalAmount } from './total-amount';

/**
 * Basic Pitch serializer used on list action.
 */
export interface PitchBasic {
  readonly id: string;
  readonly slug: string | null;
  readonly first_end_date: string | null;
  readonly name: string;
  readonly company: Company;
  readonly min_goal: string | null;
  readonly max_goal: string | null;
  readonly equity_offered: string | null;
  readonly days_left: number;
  readonly invested: TotalAmount;
  readonly short_description: string;
  readonly pre_money_eval: string | null;
  readonly banner: string;
  readonly last_invested: string;
  readonly start_date: string | null;
  /**
   * Pitches are closed every half hour
   */
  readonly end_day: string | null;
  /**
   * public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -
   */
  readonly visibility: VisibilityEnum;
  readonly payment_due: string | null;
  readonly homepage: string | null;
  limit_payment_options_to: DeckPitchDetailLimitPaymentOptionsTo | null;
  readonly is_subscribed: boolean;
  readonly use_teaser: boolean;
  readonly featured: boolean;
  readonly teaser_url: string;
  readonly tax_deducted: boolean | null;
  readonly seo_image: string;
  readonly labels: Array<string>;
  readonly compensation: string;
}
export namespace PitchBasic {}
